import { Injectable } from '@angular/core';
import { CONTENT_TYPE_PDF } from '@shared/constants/files';
import { FileHandlerBaseService } from '@shared/services/file-handler/file-handler-base.service';
import {
  PdfFile,
  ProductComparePdfHandlerService,
} from './product-compare-pdf-handler.service';
import { ModalController, Platform } from '@ionic/angular';
import { LoadingSpinnerService } from '../../shared/services/loading-spinner/loading-spinner.service';
import { ModalService } from '../../shared/services/modal/modal.service';
import { PlatformService } from '@panamax/app-state';
import { ProductAnalyticsService } from '@usf/ngrx-product';
import { TranslateService } from '@ngx-translate/core';
import { SentenceCasePipe } from '../../shared/pipes/sentence-case.pipe';
import { ServiceHandlerService } from '../../shared/services/service-handler.service';
import { ImageConverterHelpersService } from '../../shared/helpers/image-converter.helpers.service';
import { ProductDetailViewModel } from '../../product-detail/models/product-detail-view-model';

@Injectable({
  providedIn: 'root',
})
export class ProductComparePrintHandlerService extends ProductComparePdfHandlerService {
  constructor(
    translateService: TranslateService,
    sentenceCasePipe: SentenceCasePipe,
    serviceHandler: ServiceHandlerService,
    imageConverterService: ImageConverterHelpersService,
    platform: Platform,
    loadingSpinnerService: LoadingSpinnerService,
    modalController: ModalController,
    modalService: ModalService,
    platformService: PlatformService,
    private fileHandlerBaseService: FileHandlerBaseService,
    private productAnalyticsService: ProductAnalyticsService,
  ) {
    super(
      platform,
      loadingSpinnerService,
      translateService,
      sentenceCasePipe,
      serviceHandler,
      imageConverterService,
      modalController,
      modalService,
      platformService,
    );
  }

  protected override getRootPageParams(): {
    title: string;
    confirmButton: string;
  } {
    return {
      title: 'i18n.search.searchCompare.printModalTitle',
      confirmButton: 'i18n.common.print',
    };
  }

  protected override handleNative(pdfFile: PdfFile) {
    this.fileHandlerBaseService.downloadFile(
      pdfFile.data,
      pdfFile.fileName,
      CONTENT_TYPE_PDF,
      true,
      false,
    );
  }

  protected override generateFileName(
    productDetails: ProductDetailViewModel[],
  ): string {
    let fileName = this.translateService.instant(
      'i18n.search.searchCompare.title',
    );
    const productNumbers = productDetails?.map(
      productDetail => productDetail?.productNumber,
    );
    if (productNumbers?.every(productNumber => !!productNumber)) {
      for (const productNumber of productNumbers) {
        fileName += ` #${productNumber}`;
      }
    }
    return `${fileName?.replace(/[/\\.?%*:|"<>]/g, '_')?.trim()}.pdf`;
  }

  protected override handleNonNative(pdfFile: PdfFile) {
    this.fileHandlerBaseService.printWeb(pdfFile.data, CONTENT_TYPE_PDF);
  }

  protected override runAnalytics() {
    this.productAnalyticsService.trackPrintProductComparison();
  }

  protected override doCleanup() {
    this.fileHandlerBaseService.cleanUp();
  }
}
